<template>
	<edit-user-form form-type="residentPersonalInfo">
		<template #default="{ form, rules, inputColor, canEdit, update }">
			<v-row class="pa-2" dense>
				<!-- FIRST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.firstName"
						:rules="[rules.required]"
						:color="inputColor"
						label="First Name"
						:readonly="!canEdit"
						@input="update(['firstName', $event])"
					/>
				</v-col>
				<!-- LAST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.lastName"
						:rules="[rules.required]"
						:color="inputColor"
						label="Last Name"
						:readonly="!canEdit"
						@input="update(['lastName', $event])"
					/>
				</v-col>
				<!-- ADDRESS -->
				<v-col cols="12" sm="6">
					<!-- Address is actually mutated with the `roomNumber` field, but queried in `address` -->
					<v-text-field
						v-model="form.data.address"
						:color="inputColor"
						label="Address"
						:readonly="!canEdit"
						@input="update(['roomNumber', $event])"
					/>
				</v-col>
				<!-- BUILDING -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.building"
						:color="inputColor"
						label="Building"
						:readonly="!canEdit"
						@input="update(['building', $event])"
					/>
				</v-col>
				<!-- PRIMARY PHONE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.primaryPhone"
						:rules="[rules.phone]"
						:color="inputColor"
						label="Primary Phone"
						:readonly="!canEdit"
						@input="update(['primaryPhone', $event])"
					/>
				</v-col>
				<!-- SECONDARY PHONE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.secondaryPhone"
						:rules="[rules.phone]"
						:color="inputColor"
						label="Secondary Phone"
						:readonly="!canEdit"
						@input="update(['secondaryPhone', $event])"
					/>
				</v-col>
				<!-- EMAIL -->
				<v-col cols="12">
					<v-text-field
						v-model="form.data.email"
						:rules="[rules.required, rules.email]"
						:color="inputColor"
						label="Email"
						type="email"
						:readonly="!canEdit"
						@input="update(['email', $event])"
					/>
				</v-col>
				<!-- BIRTHDAY -->
				<v-col cols="12" sm="6">
					<date-field
						v-model="form.data.birthdate"
						:color="inputColor"
						label="Birthday"
						:readonly="!canEdit"
						:max="new Date().toISOString().substr(0, 10)"
						min="1900-01-01"
						@input="update(['birthdate', $event])"
					/>
				</v-col>
				<!-- GENDER -->
				<v-col cols="12" sm="6">
					<v-select
						v-model="form.data.gender"
						:rules="[rules.required]"
						:color="inputColor"
						label="Gender"
						:items="['Male', 'Female']"
						:append-icon="canEdit ? 'fa-caret-down' : ''"
						:readonly="!canEdit"
						@input="update(['gender', $event])"
					/>
				</v-col>
			</v-row>
		</template>
	</edit-user-form>
</template>

<script>
import EditUserForm from "./EditUserForm";
import DateField from "@/components/shared/DateField";

export default {
	components: { EditUserForm, DateField },
};
</script>
